import { FC, Key } from 'react';
import Table, { ColumnType } from 'antd/lib/table';
import ModalAtom, { ModalAtomProps } from 'components/atoms/ModalAtom';
import DefaultButton from 'components/atoms/Button/DefaultButton';
import PrimaryButton from 'components/atoms/Button/PrimaryButton';
import { MultipleItemListModel } from 'components/pages/AssetPage/Tabs/TabConsumption/OptionList/resources/models';
import SpaceAtom from 'components/atoms/SpaceAtom';
import './styles.scss'

export interface MultipleTagEditorOptionsModel {
  translations: Record<string, string>;
  columns: ColumnType<MultipleItemListModel>[];
  tags: MultipleItemListModel[];
  selectedRowKeys: Key[];
  onCloseMultipleTagEditorModal: () => void;
  onChangeMultipleTagEditorSensor: (sensors: Key[], selectedRows: MultipleItemListModel[]) => void;
  onUpdateGatewayWithNewSensors: () => Promise<void>;
  multipleTagEditorModalVisible: boolean;
  loading: boolean;
  updating: boolean;
}

interface Props extends ModalAtomProps {
  modalOptions: MultipleTagEditorOptionsModel;
}

const TABLE_HEIGHT = 400;

const MultipleTagEditorModal: FC<Props> = ({ onCancel, modalOptions, ...props }) => {
  const {
    translations,
    columns,
    tags,
    selectedRowKeys,
    onChangeMultipleTagEditorSensor,
    onUpdateGatewayWithNewSensors,
    loading,
    updating,
  } = modalOptions;

  const { title, mainButtonText, secondaryButtonText, selectedTagsText } = translations;

  return (
    <ModalAtom
      {...props}
      title={<SpaceAtom>{title}</SpaceAtom>}
      onCancel={onCancel}
      destroyOnClose
      width={'75%'}
      footer={[
        <DefaultButton key={'back'} onClick={onCancel} title={secondaryButtonText} />,
        <PrimaryButton key={'submit'} loading={updating} onClick={onUpdateGatewayWithNewSensors} title={mainButtonText} />,
      ]}
    >
      <div>
        <p>{selectedTagsText}</p>
        <Table<MultipleItemListModel>
          className={'MultipleTagEditorModal__expanded-table-wrapper'}
          loading={loading}
          columns={columns}
          rowKey={'key'}
          dataSource={tags}
          pagination={false}
          bordered
          scroll={{ y: TABLE_HEIGHT }}
          rowSelection={{
            selectedRowKeys,
            onChange: onChangeMultipleTagEditorSensor,
            checkStrictly: false,
          }}
        />
      </div>
    </ModalAtom>
  );
}

export default MultipleTagEditorModal;